import Component from '@glimmer/component';
import { getOwner } from '@ember/application';
import '../lib/utility/ajax.js';
import '@ember/object';
import '@ember/utils';
import 'moment-timezone';
import { paginatorPageLists } from '../lib/utility/pagination.js';
import 'ember-inflector';
import '../lib/utility/province.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\'grid-x align-center\'>\n  <div class=\'cell\'>\n    <ul class=\'pagination text-center\'>\n      {{#each this.pageLists as |page|}}\n        <li><LinkTo\n            class=\'{{page.class}}\'\n            aria-current={{if (and this.isNuova (eq page.class \'active\')) \'page\'}}\n            @query={{hash pag=page.link}}\n          >{{page.name}}</LinkTo></li>\n      {{/each}}\n    </ul>\n  </div>\n</div>");

class BbPaginatorComponent extends Component {
  get pageLists() {
    const {
      meta
    } = this.args || {};
    const {
      total_pages,
      actual_page
    } = meta || {};
    if (total_pages && actual_page) {
      return paginatorPageLists(total_pages, actual_page);
    }
    return null;
  }

  // «UI nuova» only (classic markup unchanged): the current page carries aria-current='page'
  // (components/lists.md §5). Optional lookup: an app without service:ui keeps the classic markup.
  get isNuova() {
    return Boolean(getOwner(this)?.lookup('service:ui')?.isNuova);
  }
}
setComponentTemplate(TEMPLATE, BbPaginatorComponent);

export { BbPaginatorComponent as default };
//# sourceMappingURL=bb-paginator.js.map
